import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useSidebarDrawer } from "../../context/SidebarDrawerContext";
import { SidebarNav } from "./SidebarNav";
import { Logo } from "./Logo";

export function Sidebar() {
  const { isOpen, onClose } = useSidebarDrawer();

  const isDrawerSidebar = useBreakpointValue({
    base: true,
    lg: false,
  });

  const isMobileVersion = useBreakpointValue({
    base: false,
    sm: true,
  });

  if (isDrawerSidebar) {
    return (
      <Drawer isOpen={isOpen} placement="left" onClose={onClose} size={isMobileVersion ? "xs" : "full"}>
        <DrawerOverlay>
          <DrawerContent alignItems="center" justifyContent="center"  backgroundColor="black">
            <DrawerCloseButton color="white" size="lg"/>
            <Logo/>

            <DrawerBody p={0}>
              <SidebarNav />
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    );
  }

  return (
    <Box as="aside" w="210px" bg="dark" height="100%" borderRadius={8}>
      <SidebarNav />
    </Box>
  );
}
